import { VStack } from 'tio-reimagined/components/layout';

<template>
  <VStack>{{outlet}}</VStack>
</template>
